import Reacta from "react";
import Payment_1 from "../components/paymentPage_1/Payment_1";

const Crowdfunding_1 = () => {
  return (
    <div className="Crowdfunding_1 flex h-screen items-center">
      <div className="">
        <Payment_1 />
      </div>
    </div>
  );
};

export default Crowdfunding_1;
